import { render, staticRenderFns } from "./CbsClipboardImport.vue?vue&type=template&id=673d024a"
import script from "./CbsClipboardImport.vue?vue&type=script&lang=js"
export * from "./CbsClipboardImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports